import { render, staticRenderFns } from "./SwiperPosts.vue?vue&type=template&id=4d976e03&"
import script from "./SwiperPosts.vue?vue&type=script&lang=js&"
export * from "./SwiperPosts.vue?vue&type=script&lang=js&"
import style0 from "./SwiperPosts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports